import { render } from "./huasTrade.vue?vue&type=template&id=8f2f7c7c&scoped=true"
import script from "./huasTrade.vue?vue&type=script&lang=js"
export * from "./huasTrade.vue?vue&type=script&lang=js"

import "./huasTrade.vue?vue&type=style&index=0&id=8f2f7c7c&lang=scss&scoped=true"
import "./huasTrade.vue?vue&type=style&index=1&id=8f2f7c7c&lang=css"

import exportComponent from "E:\\Source\\HuasCo\\personal-web\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f2f7c7c"]])

export default __exports__